export default "__VITE_ASSET__uoopS5lf__"